import React, {useEffect, useRef, useState} from "react";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";
import "./accordion.sass";
import classNames from "classnames";

export interface IAccordionProps {
  isExpanded?: boolean;
  header: (isExpended: boolean) => React.ReactNode;
  id: string;
  setIsExpanded: (id: string, isExpanded: boolean) => void;
  toggleIcon?: IconSource;
  toggleIconColor?: "primary" | "secondary";
  hideToggleIcon?: boolean;
}

const Accordion: React.FC<IAccordionProps> = ({
  isExpanded = false,
  header,
  id,
  setIsExpanded,
  children,
  toggleIcon = IconSource.angleUp,
  toggleIconColor = "secondary",
  hideToggleIcon = false
}) => {
  const contentEl = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const childrenHeight = Array.from(contentEl.current?.children || []).reduce(
      (acc, child) => {
        acc = acc + child.scrollHeight;
        return acc;
      },
      0
    );
    if (childrenHeight !== height) {
      setHeight(childrenHeight);
    }
  });

  return (
    <div
      className={classNames("accordion card", {
        isExpanded: isExpanded,
        [toggleIconColor]: true
      })}
      data-testid={"accordion-" + id}
    >
      <div className="header">
        <button
          className="btn control"
          type="button"
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded(id, !isExpanded)}
        >
          {header(isExpanded)}
          {!hideToggleIcon && <Icon source={toggleIcon} id={toggleIcon} />}
        </button>
      </div>

      <div
        ref={contentEl}
        className={classNames("expandable", {expanded: isExpanded})}
        style={isExpanded ? {height} : {height: "0px"}}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
